"use strict";

var _interopRequireWildcard = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadMenus = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.join.js");

var _objectSpread2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _router = _interopRequireWildcard(require("@/router"));

var _store = _interopRequireDefault(require("./store"));

var _elementUi = require("element-ui");

var _nprogress = _interopRequireDefault(require("nprogress"));

require("nprogress/nprogress.css");

var _auth = require("@/utils/auth");

var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));

var _common = require("@/api/common");

var _permission = require("@/store/modules/permission");

var _utils = require("./utils");

// progress bar
// progress bar style
// get token from cookie
_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration


var whiteList = ['/login']; // no redirect whitelist
// 跳过登录验证注释 start

_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, data, _JSON$parse, loginData, hasGetUserInfo;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            // NProgress.start()
            // set page title
            document.title = (0, _getPageTitle.default)(to.meta.title); // determine whether the user has logged in

            hasToken = (0, _auth.getToken)();

            if (!hasToken) {
              _context.next = 32;
              break;
            }

            if (!(to.path === '/login')) {
              _context.next = 7;
              break;
            }

            // if is logged in, redirect to the home page
            next({
              path: '/'
            }); // NProgress.done()

            _context.next = 30;
            break;

          case 7:
            data = localStorage.getItem((0, _utils.getStorageKey)('userInfo'));
            _JSON$parse = JSON.parse(data), loginData = Object.assign({}, _JSON$parse);
            hasGetUserInfo = _store.default.getters.name ? _store.default.getters.name : loginData.nickname;

            if (!(to.name === 'GoVIP' || to.name === 'PayVip')) {
              _context.next = 14;
              break;
            }

            next();
            _context.next = 30;
            break;

          case 14:
            if (!hasGetUserInfo) {
              _context.next = 20;
              break;
            }

            _context.next = 17;
            return _store.default.dispatch('user/getInfo');

          case 17:
            if (!_store.default.getters.vipLevel) {
              next("/govip");
            } else {
              next();
            } // loadMenus(next, to)


            _context.next = 30;
            break;

          case 20:
            _context.prev = 20;
            // get user info
            next(); // loadMenus(next, to)

            _context.next = 30;
            break;

          case 24:
            _context.prev = 24;
            _context.t0 = _context["catch"](20);
            _context.next = 28;
            return _store.default.dispatch('user/resetToken');

          case 28:
            _elementUi.Message.error(_context.t0 || 'Has Error');

            next("/login"); // NProgress.done()

          case 30:
            _context.next = 33;
            break;

          case 32:
            /* has no token*/
            // next()
            if (whiteList.indexOf(to.path) !== -1) {
              // in the free login whitelist, go directly
              next();
            } else {
              // other pages that do not have permission to access are redirected to the login page.
              next("/login?=".concat(to.path)); // NProgress.done()
            }

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[20, 24]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}()); // 跳过登录验证注释 end


var PermissionRouter = function PermissionRouter(next, to, data, group_id) {
  (0, _router.resetRouter)(); // addRoutes(routes)之前调用resetRouter()清空路由，防止出现路由未定义的报错

  var asyncRouter = (0, _permission.filterAsyncRouter)(data, group_id);
  asyncRouter.push({
    path: '*',
    redirect: '/404',
    hidden: true
  });

  _store.default.dispatch('permission/GenerateRoutes', asyncRouter).then(function () {
    // 存储路由
    _router.default.addRoutes(asyncRouter); // 动态添加可访问路由表


    next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
      replace: true
    }));
  });
};

var loadMenus = function loadMenus(next, to) {
  var data = localStorage.getItem((0, _utils.getStorageKey)('userInfo'));

  var _JSON$parse2 = JSON.parse(data),
      loginData = Object.assign({}, _JSON$parse2);

  (0, _common.getGroupPermission)({
    group_id: loginData.group_id
  }).then(function (res) {
    localStorage.setItem((0, _utils.getStorageKey)('group_permission_' + loginData.group_id), res.data.data.join(','));
    PermissionRouter(next, to, res.data.data, loginData.group_id);
  }).catch(function () {
    PermissionRouter(next, to, [], loginData.group_id);
  });
};

exports.loadMenus = loadMenus;

_router.default.afterEach(function () {// finish progress bar
  // NProgress.done()
});